import React from 'react';
import Button from './Button';

// Empty / error state (handoff_app_design/README.md §4.10). One muted icon, one sentence saying
// what is missing or what failed, one action button. Never a generic "שגיאה לא צפויה".
//
//   <EmptyState icon={<CalendarBlank/>} message="עדיין אין לך תכנית לשבוע הזה" action={{ label: 'צור תכנית', onClick }} />
export default function EmptyState({ icon, message, action, className = '' }) {
  return (
    <div className={`flex flex-col items-center text-center gap-3 py-10 px-5 ${className}`}>
      {icon && <span className="text-text-muted text-[28px] flex items-center justify-center">{icon}</span>}
      <p className="font-medium text-[15px] text-text-body max-w-[26ch]">{message}</p>
      {action && (
        <Button fullWidth={false} onClick={action.onClick} className="mt-1 px-6">
          {action.label}
        </Button>
      )}
    </div>
  );
}
